import { type CartItem } from '@/store/use-cart.store';

/**
 * Calculate the total quantity of products in the active single-vendor cart.
 */
export const calculateCartTotalCount = (cartItems: CartItem[]): number => {
  const activeCart = cartItems.find((cart) => cart.products.length > 0);
  if (!activeCart) return 0;

  return activeCart.products.reduce(
    (totalCount, product) => totalCount + product.quantity,
    0
  );
};
